import React from 'react';

import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import TawkToChat from '../tawkto';

function GeneralLayout() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {/* Content of Login/Register or other exempted pages will go here */}
      <Outlet />
       <TawkToChat />
    </Box>
  );
}

export default GeneralLayout;
